import Rollbar from 'rollbar';
import rollBarOption from './rollbar-option';

export default new Rollbar(rollBarOption);
